enum AssetCounterFieldNames {
  Code = 'code',
  MeasureType = 'measureType',
  MeasureUnit = 'measureUnit',
  Name = 'name',
  ProhibitLowerIndexThanPrevious = 'prohibitLowerIndexThanPrevious',
  ProhibitLowerIndexThanPreviousField = 'prohibitLowerIndexThanPreviousField',
}

export default AssetCounterFieldNames;
